var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.9922 26.4983C27.1262 23.2845 24.138 20.8741 20.6022 19.7305C22.2961 18.7226 23.6123 17.1865 24.3486 15.3581C25.0849 13.5297 25.2006 11.5101 24.678 9.60959C24.1553 7.70906 23.0232 6.03267 21.4555 4.83789C19.8878 3.64311 17.9712 2.99603 16.0001 2.99603C14.029 2.99603 12.1125 3.64311 10.5448 4.83789C8.97705 6.03267 7.84493 7.70906 7.32228 9.60959C6.79962 11.5101 6.91534 13.5297 7.65165 15.3581C8.38796 17.1865 9.70415 18.7226 11.3981 19.7305C7.86232 20.874 4.87417 23.2844 3.00823 26.498C2.92028 26.65 2.87391 26.8225 2.87378 26.9981C2.87365 27.1738 2.91978 27.3463 3.00751 27.4984C3.09525 27.6506 3.2215 27.7769 3.37357 27.8647C3.52564 27.9526 3.69816 27.9988 3.87377 27.9988L28.1266 27.9991C28.3023 27.9991 28.4748 27.9529 28.6269 27.865C28.7789 27.7772 28.9052 27.6508 28.9929 27.4987C29.0807 27.3466 29.1268 27.174 29.1267 26.9984C29.1265 26.8228 29.0801 26.6503 28.9922 26.4983L28.9922 26.4983Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/User.33abd265.svg";
export { ForwardRef as ReactComponent };